/**
 * Jackpot Millions Scratch Card Configuration
 */

import { JACKPOT_MILLIONS_CONFIG as CONFIG } from '../ScratchCardConfigs';

// Export as both named and default export
export const JACKPOT_MILLIONS_CONFIG = CONFIG;
export default JACKPOT_MILLIONS_CONFIG;
